import React, { useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import StandAloneLayout from '../layouts/StandAloneLayout/StandAloneLayout';
import { login, AUTH_ERROR } from '@t7x000/apex-web/lib/redux/actions/authActions.js';
import { showSnack } from '@t7x000/apex-web/lib/redux/actions/snackbarActions';

const FORM_ID = 'login-trade';

const LoginTrade = ({ handleLogin, isConnected }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorText, setErrorText] = useState('');

  const canSubmit = useMemo(() => {
    return !!isConnected && !!username && !!password && !isSubmitting;
  }, [isConnected, username, password, isSubmitting]);

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (!canSubmit) return;

      setErrorText('');
      setIsSubmitting(true);
      try {
        await handleLogin({
          username,
          password,
          JWTToken: generateRandomToken(),
          setErrorText,
        });
      } finally {
        setIsSubmitting(false);
      }
    },
    [canSubmit, handleLogin, username, password],
  );

  return (
    <StandAloneLayout>
      <div
        style={{
          width: 320,
          margin: 'auto auto',
          padding: 24,
          borderRadius: 8,
          border: '1px solid #ccc',
        }}>
        <h2 style={{ margin: '0 0 16px 0' }}>Login Trade</h2>
        <form id={FORM_ID} onSubmit={onSubmit}>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', marginBottom: 6 }}>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              style={{ width: '100%', padding: 10 }}
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 6 }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              style={{ width: '100%', padding: 10 }}
            />
          </div>
          <button
            type="submit"
            disabled={!canSubmit}
            style={{
              width: '100%',
              padding: 12,
              backgroundColor: '#0171b6',
              cursor: 'pointer',
              color: 'white',
            }}>
            {isSubmitting ? 'Logging in…' : 'Log In'}
          </button>
          {!!errorText && <div style={{ marginTop: 12, color: '#b00020' }}>{errorText}</div>}
        </form>
      </div>
    </StandAloneLayout>
  );
};

const mapStateToProps = (state) => ({
  isConnected: state.wsConnection.isConnected,
});

const mapDispatchToProps = (dispatch) => ({
  handleLogin: async (payload) => {
    return dispatch(login({ username: payload.username, password: payload.password })).then((action) => {
      if (action.type === AUTH_ERROR) {
        const msg = action?.payload?.errorMsg || payload?.errorMsg || 'Invalid username or password';
        if (typeof payload?.setErrorText === 'function') {
          payload.setErrorText(msg);
        }
        dispatch(
          showSnack({
            id: 'loginTradeAuthError',
            text: msg,
            type: 'warning',
          }),
        );
      } else {
        localStorage.setItem('JWTToken', payload.JWTToken);
        sessionStorage.setItem('isFromLoginTrade', 'true');
      }
      return action;
    });
  },
});

const LoginTradeContainer = connect(mapStateToProps, mapDispatchToProps)(LoginTrade);

export default withRouter(LoginTradeContainer);

function generateRandomToken() {
  const bytes = new Uint8Array(32);
  window.crypto.getRandomValues(bytes);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary).replace(/=+$/g, '');
}
